import React from 'react';
import './Footer.css'

export default function Footer() {
    return (
        <footer id="footer">
            <div className="footer-sitemap">
                <div className="limits clearfix">
                    <div className="footer-sitemap-col-new" style={{width: '195px'}}>
                        <dl>
                            <dt>Institucional</dt>
                            <dd><a href="https://www.alepe.pe.gov.br/historia" title="História da Alepe">História da Alepe</a></dd>
                            <dd><a href="https://www.alepe.pe.gov.br/estrutura-administrativa" title="Estrutura Administrativa">Estrutura Administrativa</a></dd>
                            <dd><a href="https://www.alepe.pe.gov.br/estrutura" title="Estrutura Legislativa">Estrutura Legislativa</a></dd>
                            <dd><a href="https://www.alepe.pe.gov.br/enquetes" title="Enquetes">Enquetes</a></dd>
                            <dd><a href="https://www.alepe.pe.gov.br/municipios" title="Municípios Pernambucanos">Municípios Pernambucanos</a></dd>
                            <dd><a href="https://www.alepe.pe.gov.br/assembleia-360" title="Assembleia em 360º">Assembleia em 360º</a></dd>
                            <dd><a href="https://www.alepe.pe.gov.br/projetos-sociais" title="Projetos Sociais">Projetos Sociais</a></dd>
                            <dd><a href="https://comunidade.alepe.pe.gov.br/" target="_blank" title="Comunidade Alepe">Comunidade Alepe</a></dd>
                        </dl>

                        <dl>
                            <dt>Aplicativos da Alepe</dt>
                            <dd><a href="https://www.alepe.pe.gov.br/aplicativos" title="Aplicativos">Acesse os aplicativos</a></dd>
                        </dl>
                    </div>

                    <div className="footer-sitemap-col-new" style={{width: '210px'}}>
                        <dl>
                            <dt>Atividade Legislativa</dt>
                            <dd><a href="https://www.alepe.pe.gov.br/proposicoes" title="Propostas Legislativas">Propostas Legislativas</a></dd>
                            <dd><a href="https://www.alepe.pe.gov.br/reunioes" title="Reuniões">Reuniões</a></dd>
                            <dd><a href="https://www.alepe.pe.gov.br/agenda" title="Agenda">Agenda</a></dd>
                            <dd><a href="https://www.alepe.pe.gov.br/ordem-do-dia" title="Ordem do dia">Ordem do dia</a></dd>
                            <dd><a href="https://www.alepe.pe.gov.br/atos-portarias" title="Atos e Portarias">Atos e Portarias</a></dd>
                            <dd><a href="https://www.alepe.pe.gov.br/loa" title="Leis Orçamentárias">Leis Orçamentárias</a></dd>
                            <dd><a href="https://www.alepe.pe.gov.br/publicacoes" title="Outras Publicações">Publicações</a></dd>
                        </dl>

                        <dl>
                            <dt><a href="https://www.alepe.pe.gov.br/parlamentares" title="Deputados">Deputados</a></dt>
                        </dl>
                    </div>

                    <div className="footer-sitemap-col-new" style={{width: '130px'}}>
                        <dl>
                            <dt>Imprensa</dt>
                            <dd><a href="https://www.alepe.pe.gov.br/noticias" title="Últimas Notícias">Últimas Notícias</a></dd>
                            <dd><a href="https://www.alepe.pe.gov.br/tv-alepe" title="TV Alepe">TV Alepe</a></dd>
                            <dd><a href="https://www.alepe.pe.gov.br/radio-alepe" title="Rádio Alepe">Rádio Alepe</a></dd>
                            <dd><a href="https://www.alepe.pe.gov.br/galeria" title="Fotojornalismo">Fotojornalismo</a></dd>
                            <dd><a href="https://www.alepe.pe.gov.br/noticias-especiais" title="Notícias Especiais">Notícias Especiais</a></dd>
                            <dd><a href="https://www.alepe.pe.gov.br/do" title="Diário Oficial">Diário Oficial</a></dd>
                            <dd><a href="https://www.alepe.pe.gov.br/sala-de-imprensa" title="Sala de Imprensa">Sala de Imprensa</a></dd>
                        </dl>

                        <dl>
                            <dt><a href="http://legis.alepe.pe.gov.br" target="_blank" title="Ir para o portal de Legislação">Legislação</a></dt>
                            <dd><a href="http://legis.alepe.pe.gov.br/arquivoTexto.aspx?tiponorma=12&numero=1989&complemento=0&ano=1989&tipo=" target="_blank" title="Constituição Estadual">Constituição Estadual</a></dd>
                            <dd><a href="https://legis.alepe.pe.gov.br/texto.aspx?tiponorma=4&numero=1891&complemento=0&ano=2023&tipo=&url=" target="_blank" title="Regimento Interno">Regimento Interno</a></dd>
                            <dd><a href="http://legis.alepe.pe.gov.br/arquivoTexto.aspx?tiponorma=4&numero=646&complemento=0&ano=2003&tipo=" target="_blank" title="Código de Ética">Código de Ética</a></dd>
                            <dd><a href="http://legis.alepe.pe.gov.br" target="_blank" title="Alepe Legis">Alepe Legis</a></dd>
                        </dl>
                    </div>

                    <div className="footer-sitemap-col-new last" style={{width: '180px'}}>
                        <dl>
                            <dt>Transparência</dt>
                            <dd><a href="https://transparencia.alepe.pe.gov.br" title="Portal da Transparência" target="_blank">Portal da Transparência</a></dd>
                            <dd><a href="https://transparencia.alepe.pe.gov.br/ouvidoria" title="SIC e Ouvidoria" target="_blank">SIC e Ouvidoria</a></dd>
                            <dd><a href="https://transparencia.alepe.pe.gov.br/legislacao" title="Legislação" target="_blank">Legislação</a></dd>
                            <dd><a href="https://transparencia.alepe.pe.gov.br/pessoal" title="Gestão de Pessoas" target="_blank">Gestão de Pessoas</a></dd>
                            <dd><a href="https://transparencia.alepe.pe.gov.br/financas" title="Prestação de Contas" target="_blank">Prestação de Contas</a></dd>
                            <dd><a href="https://dadosabertos.alepe.pe.gov.br" title="Portal de dados abertos" target="_blank">Portal de Dados Abertos</a></dd>
                        </dl>
                    </div>

                    <div className="footer-sitemap-col-new last" style={{width: '170px'}}>
                        <img src="https://www.alepe.pe.gov.br/wp-content/themes/alepe/image/alepe-logo-branca-rodape.png" style={{maxWidth: '170px'}} alt="Logotipo da Alepe"/>
                        <span className="visuallyhidden">Alepe - Assembleia Legislativa do Estado de Pernambuco</span>
                        <div className="social-footer-icon">
                            <div className="social-media-flex">
                                <a href="http://www.facebook.com/assembleiape" target="_blank" title="Alepe - Facebook">
                                    <img src="https://www.alepe.pe.gov.br/wp-content/themes/alepe/image/facebook.png" style={{width:'25px'}} alt="Facebook"/>
                                </a>
                                <a href="http://www.twitter.com/alepeoficial" target="_blank" title="Alepe - Twitter">
                                    <img src="https://www.alepe.pe.gov.br/wp-content/themes/alepe/image/x.png" style={{width:'25px'}} alt="Twitter"/>
                                </a>
                                <a href="http://www.instagram.com/assembleiape" target="_blank" title="Alepe - Instagram">
                                    <img src="https://www.alepe.pe.gov.br/wp-content/themes/alepe/image/instagram.png" style={{width:'25px'}} alt="Instagram"/>
                                </a>
                                <a href="http://www.youtube.com/alepenatv" target="_blank" title="Alepe - Youtube">
                                    <img src="https://www.alepe.pe.gov.br/wp-content/themes/alepe/image/youtube.png" style={{width:'25px'}} alt="Youtube"/>
                                </a>
                                <a href="https://www.tiktok.com/@assembleiape" target="_blank" title="Alepe - TikTok">
                                    <img src="https://www.alepe.pe.gov.br/wp-content/themes/alepe/image/tiktok.png" style={{width:'25px'}} alt="TikTok"/>
                                </a>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div style={{color: '#7b6b5a'}}>
                <div className="limits clearfix">
                    <div className="row d-flex align-items-start">
                        <div className="col-4" style={{marginTop: '28px'}}>
                            <div>
                                <p className="footer-title-new">HORÁRIO DE FUNCIONAMENTO</p>
                                <p style={{color: '#011b53', fontWeight: 'bold'}}>Segunda a quinta: 8h às 18h</p>
                                <p style={{color: '#011b53', fontWeight: 'bold'}}>Sexta: 8h às 13h</p>
                                <p className="footer-title-new" style={{marginTop:'25px'}}>FONE E EMAIL</p>
                                <p style={{color: '#011b53', fontWeight: 'bold'}}>(81) 3183-2211</p>
                                <p style={{color: '#011b53', fontWeight: 'bold'}}>alepe@alepe.pe.gov.br</p>
                            </div>
                        </div>
                        <div className="col-4" style={{marginTop: '28px'}}>
                            <div id="como-chegar">
                                <a style={{textDecoration: 'none', color: '#7b6b5a', fontWeight: 'normal'}}>
                                    <p className="footer-title-new" style={{display: 'inline-block', position: 'relative', color: '#7b6b5a', fontWeight: 'bold', textDecoration: 'none', paddingBottom: '5px'}}>
                                        <img src="https://www.alepe.pe.gov.br/wp-content/themes/alepe/image/localizacao.png" style={{width: '15px', marginRight: '8px'}} alt=""/>COMO CHEGAR
                                        <span style={{position: 'absolute', bottom: '0', left: '0', height: '2px', width: '100%', backgroundColor: '#7b6b5a'}}></span>
                                    </p>
                                    <address id="address" style={{color: '#011b53', fontWeight: 'bold', marginTop: '15px'}}>
                                        Rua da União, 397, Boa Vista, Recife, <br/>
                                        Pernambuco, Brasil, CEP: 50050-909<br/>
                                        CNPJ: 11.426.103/0001-34<br/>
                                    </address>
                                </a>
                            </div>
                        </div>
                        <div className="col-4" style={{marginTop: '28px', paddingLeft: '20px'}}>
                            <div>
                                <p className="footer-title-new">SERVIÇO DE INFORMAÇÃO AO CIDADÃO E OUVIDORIA</p>
                                <p style={{color: '#011b53', fontWeight: 'bold'}}>(81) 3183-2002</p>
                                <p style={{color: '#011b53', fontWeight: 'bold'}}>ouvidoria@alepe.pe.gov.br</p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12 text-center">
                            <div id="maps-rodape" className="tabs-content" style={{display: 'none'}}>
                                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3950.4200556844103!2d-34.88240728522003!3d-8.058563694197607!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x7ab18be5d84518f%3A0xe632e9e4f352f199!2sR.+da+Uni%C3%A3o%2C+397+-+Boa+Vista%2C+Recife+-+PE%2C+50050-010!5e0!3m2!1spt-BR!2sbr!4v1503492961881" width="700" height="300" frameBorder="0" style={{border:0}} allowFullScreen></iframe>

                                <br/><br/>
                                <div className="coluna-flex">
                                    <span className="col-flex-1">
                                        <p><strong>Sede: <br/>Edifício Governador Miguel Arraes de Alencar </strong><br/>
                                        Rua da União, 397 - Boa Vista, Recife/PE<br/>
                                        CEP: 50050-909</p><br/>
                                    </span>

                                    <span className="col-flex-1">
                                        <p><strong>Gabinetes parlamentares: <br/>Anexo II - Edf. João Negromonte Filho</strong><br/>
                                        Rua da União, 383 - Boa Vista, Recife/PE<br/>
                                        CEP: 50050-909</p>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}